export default "__VITE_ASSET__Bmtp1P4G__"